const MAX_SAMPLES = 40;
const deltas: number[] = [];
let lastScrollY: number | null = null;
let lastScrollTs: number | null = null;

if (typeof window !== 'undefined') {
  window.addEventListener(
    'scroll',
    () => {
      const now = performance.now();
      const y = window.scrollY;
      if (lastScrollY !== null && lastScrollTs !== null) {
        const dt = now - lastScrollTs;
        if (dt > 0) {
          const speed = Math.abs(y - lastScrollY) / dt;
          deltas.push(speed);
          if (deltas.length > MAX_SAMPLES) deltas.shift();
        }
      }
      lastScrollY = y;
      lastScrollTs = now;
    },
    { passive: true },
  );
}

function stddev(arr: number[]): number {
  const n = arr.length;
  if (n < 2) return 0;
  const mean = arr.reduce((a, b) => a + b, 0) / n;
  const v = arr.reduce((a, b) => a + (b - mean) ** 2, 0) / n;
  return Math.sqrt(v);
}

export function getScrollStats(): { samples: number; speedStdDev?: number } {
  if (deltas.length < 3) return { samples: deltas.length };
  return {
    samples: deltas.length,
    speedStdDev: Number(stddev(deltas).toFixed(4)),
  };
}
